import { SOFTWARE_BLACK_MNG } from '@/api/apiModules'

export default {
  refreshInterval: false,
  viewType: 'table',
  module: SOFTWARE_BLACK_MNG,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入黑名单',
    searchFieldNameArr: ['blackContent'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'SoftwareBlackListCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '黑名单',
          prop: 'blackContent'
        }
      },
      {
        props: {
          label: '加入黑名单原因',
          prop: 'reason'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'SoftwareBlackListEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'SoftwareBlackListDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.softwareBlackListMng.deleteMsg'
        }
      }
    ]
  }
}
